import React, { useState, useEffect } from "react";
import axios from "axios";
import "./CourseUpload.css";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { resources } from "../../Resourses/Resources";
import PaginationReUsable from "../../ReuseableComponent/ReusePagination";

const CourseUpload = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const previousYear = year - 3;

  let academicYear = [];
  let currentYear;
  console.log('..........months',month)
  console.log('..........previousYear',previousYear)
  console.log('..........year',year)

  for (let i = previousYear; i < year + 2; i++) {
    
    if (month < 5) {
      currentYear = i - 1 + "-" + i;
    } else {
      currentYear = i + "-" + (i + 1);
    }
    academicYear.push(currentYear);
  }

  if (month < 5) {
    currentYear = year - 1 + "-" + year;
  } else {
    currentYear = year + "-" + (year + 1);
  }

  const [courselist, setCourseList] = useState([]);
  const [viewCourseDetails, setViewCourseDetails] = useState([]);
  const [search, setSearch] = useState("");
  const [serialNo, setSerialNo] = useState("");
  const [allData, setAllData] = useState([]);
  const [paginationData, setPaginationData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [edit, setEdit] = useState(false);

  const [courseDetails, setCourseDetails] = useState({
    academicYear: currentYear,
    level: "",
    degree: "",
    branch: "",
    intakeCount: "",
    courseCode: "",
  });

  const level = ["Diploma", "Graduation", "Post Graduation"];
  const degreelist = ["Polytechnic","B.TECH", "M.TECH", "MBA", "MCA", "OTHERS"];

  const fetchCourses = async () => {
    console.log(courseDetails.academicYear)
    if (currentYear) {
      try {
        const response = await axios.get(
          resources.APPLICATION_URL +
            `getAllCourseDetailsByAcademicYear?academicYear=${courseDetails.academicYear}`
        );
        const details = response.data;
        setViewCourseDetails(details);
        setFilteredData(details);
        setAllData(details);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [courseDetails.academicYear]);

  const handleAdd = () => {
    setCourseList([...courselist, courseDetails]);
    setCourseDetails({ ...courseDetails, branch: "", intakeCount: "" });
  };



  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        resources.APPLICATION_URL + "saveCourseIntakeCount",
        courselist
        );

      console.log("Response:", response.data);

      const errorMsgEl = document.getElementById("errorMsg");

      if (response.data.status === "true") {
        if (errorMsgEl) errorMsgEl.style.display = "none";

        alert(response.data.message);

        fetchCourses();
      } else {
          setCourseList([]);
        if (errorMsgEl) {
          errorMsgEl.style.display = "block";
          errorMsgEl.textContent = response.data.message;

          setTimeout(() => {
            errorMsgEl.style.display = "none";
          }, 3000);
        }
      }
    } catch (error) {
      alert("Something went wrong");
      console.log("Submit error:", error);
    }
  };

  const handleDeleteRecord = async (item) => {
    if (!item) {
      alert("This item hasn't been saved yet. Please submit before deleting.");
      return;
    }

    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        console.log("Deleting ID:", item.id);
        const response = await axios.delete(
          `${resources.APPLICATION_URL}deleteCourseDetailsById?id=${item}`
        );
        console.log("Response:", response.data);
        alert("Data deleted");
        fetchCourses();
      } catch (err) {
        console.error("Delete failed:", err);
      }
    }
  };

  const handleEditSave = async (item) => {
    console.log(item);
    try {
      await axios.put(resources.APPLICATION_URL + `updateCoursemaster`, item);
      setEdit(false);
      setCourseDetails({
        academicYear: currentYear,
        level: "",
        degree: "",
        branch: "",
        intakeCount: "",
        courseCode: "",
      });
      fetchCourses();
    } catch (err) {
      console.error("Update failed:", err);
    }
  };

  const handleModifyRecord = () => {
    const modifiedList = [...courselist];
    const index = modifiedList.findIndex(
      (item) =>
        item.degree === courseDetails.degree &&
        item.branch === courseDetails.branch
    );
    if (index !== -1) {
      modifiedList[index] = { ...courseDetails };
      setCourseList(modifiedList);
      setCourseDetails({
        academicYear: currentYear,
        degree: "",
        branch: "",
        level: "",
        intakeCount: "",
      });
      setEdit(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    const filtered = allData.filter((each) =>
      each.branch?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
    setSearch(value);
  };

  const handleGetSpliceData = (receivedList, startSNo) => {
    setPaginationData(receivedList);
    setSerialNo(startSNo);
  };

  return (
    <div className="courseUploadMainContainer">
      <p className="headerTagStyle">Add Course Count</p>
      <div className="searchDiv">
        <input
          type="text"
          placeholder="Search By Branch..."
          value={search}
          onChange={handleSearch}
        />
      </div>
      <div className="courseUploaContainer">
        <div className="courseUploadDivCon">
          <div className="InputDiv">
            <label>Academic Year</label>
            <select
              value={courseDetails.academicYear}
              onChange={(e) =>
                setCourseDetails({
                  ...courseDetails,
                  academicYear: e.target.value,
                })
              }
            >
              <option>{currentYear}</option>
              {academicYear.map((item, idx) => (
                <option key={idx}>{item}</option>
              ))}
            </select>
          </div>
          <div className="InputDiv">
            <label>Level</label>
            <select
              value={courseDetails.level}
              onChange={(e) =>
                setCourseDetails({ ...courseDetails, level: e.target.value })
              }
            >
              <option>Please Select</option>
              {level.map((item, idx) => (
                <option key={idx}>{item}</option>
              ))}
            </select>
          </div>
          <div className="InputDiv">
            <label>Degree</label>
            <select
              value={courseDetails.degree}
              onChange={(e) =>
                setCourseDetails({ ...courseDetails, degree: e.target.value })
              }
            >
              <option>Please Select</option>
              {degreelist.map((item, idx) => (
                <option key={idx}>{item}</option>
              ))}
            </select>
          </div>
          <div className="InputDiv">
            <label>Branch</label>
            <input
              type="text"
              value={courseDetails.branch}
              onChange={(e) =>
                setCourseDetails({ ...courseDetails, branch: e.target.value })
              }
            />
          </div>
          <div className="InputDiv">
            <label>Course Code</label>
            <input
              type="text"
              value={courseDetails.courseCode}
              onChange={(e) =>
                setCourseDetails({
                  ...courseDetails,
                  courseCode: e.target.value,
                })
              }
            />
          </div>
          <div className="InputDiv">
            <label>Intake</label>
            <input
              type="text"
              value={courseDetails.intakeCount}
              onChange={(e) =>
                setCourseDetails({
                  ...courseDetails,
                  intakeCount: e.target.value,
                })
              }
            />
          </div>
          <div className="InputDiv">
            {!edit ? (
              <button onClick={handleAdd}>Add</button>
            ) : (
              <button onClick={() => handleEditSave(courseDetails)}>
                Save
              </button>
            )}
          </div>
        </div>

        <div className="towtablesView">
          <div className="tableStylesDiv">
            <table className="tableStylings">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Academic Year</th>
                  <th>Degree</th>
                  <th>Branch</th>
                  <th>Count</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(courselist) && courselist.length > 0 ? (
                  courselist.map((item, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item?.academicYear}</td>
                      <td>{item?.degree}</td>
                      <td>{item?.branch}</td>
                      <td>{item?.intakeCount}</td>
                      <td>
                        <EditOutlinedIcon
                          onClick={() => {
                            setCourseDetails(item);
                            setEdit(true);
                          }}
                        />
                        <DeleteOutlinedIcon
                          onClick={() => handleDeleteRecord(item?.uniqueKey)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colspan="6" style={{ textAlign: "center" }}>
                      Not Yet Added
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="submitButtonDiv">
              <button onClick={handleSubmit}>Submit</button>
            </div>
          </div>

          <div className="tableStylesDiv">
            <p id="errorMsg"></p>

            <table className="tableStylings">
              <thead>
                <tr>
                  <th>Sl. No</th>
                  <th>Academic Year</th>
                  <th>Level</th>
                  <th>Degree</th>
                  <th>Branch</th>
                  <th>Intake Count</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginationData.map((item, index) => (
                  <tr key={index}>
                    <td>{serialNo + index}</td>
                    <td>{item.academicYear}</td>
                    <td>{item.level}</td>
                    <td>{item.degree}</td>
                    <td>{item.branch}</td>
                    <td>{item.intakeCount}</td>
                    <td>
                      <EditOutlinedIcon
                        style={{
                          cursor: "pointer",
                          color: "blue",
                          marginRight: "8px",
                        }}
                        onClick={() => {
                          setCourseDetails(item);
                          setEdit(true);
                        }}
                      />
                      <DeleteOutlinedIcon
                        style={{ cursor: "pointer", color: "red" }}
                        onClick={() => handleDeleteRecord(item.uniqueKey)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <PaginationReUsable
        paginationData={filteredData}
        handleGetSpliceData={handleGetSpliceData}
      />
    </div>
  );
};

export default CourseUpload;
